import { atom } from 'jotai';
import { atomWithReset, RESET } from 'jotai/utils';
import { CheckPointIeltsQueryQuery, IeltsSpeakingQuestion } from '@/__generated__/graphql';

export const isFullScreenAtom = atomWithReset<boolean>(false);

export const selectedRequestReviewATom = atomWithReset<string[]>([]);
// part info is screen part info
export const isShowPartInfoPreviewAtom = atomWithReset<boolean>(true);

export const isRequestAIDiamondAtom = atomWithReset<boolean>(false);

export const isLoadingStartAtom = atomWithReset<boolean>(false);
// bottom sheet submit part or atom
export const isShowBottomSheetSubmitTestAtom = atomWithReset<boolean>(false);
// id attempt
export const attemptIdAtom = atomWithReset<string | undefined | null>(null);

export const setSelectedRequestReviewATom = atom(null, (get, set, val?: string | typeof RESET) => {
  const currentSelected = get(selectedRequestReviewATom);
  if (!val || val === RESET) {
    return set(selectedRequestReviewATom, []);
  }
  if (currentSelected.includes(val)) {
    return set(
      selectedRequestReviewATom,
      currentSelected.filter((el) => el !== val),
    );
  }
  return set(selectedRequestReviewATom, [val]);
});

export const setSelectedAiRequestReviewATom = atom(null, (_get, set) => {
  return set(selectedRequestReviewATom, ['ai']);
});

export const checkPointAtom = atomWithReset<CheckPointIeltsQueryQuery['checkPoint'] | undefined>(
  undefined,
);

export const currentQuestionIndexAtom = atomWithReset<number>(0);

export const currentPartIndexAtom = atomWithReset<number>(0);

export const isDoingAutoSubmitAtom = atomWithReset<boolean>(false);
export const loadingEndAttemptAtom = atomWithReset<boolean>(false);
export const isEndExamAtom = atomWithReset<boolean>(false);

export const checkpointInfoAtom = atom((get) => {
  const checkpoint = get(checkPointAtom);
  return {
    ...checkpoint,
    name: checkpoint?.name,
    nameEn: checkpoint?.nameEn,
    description: checkpoint?.description,
    descriptionEn: checkpoint?.descriptionEn,
    type: checkpoint?.cpType,
    isPractice: checkpoint?.type === 'IELTS_PRACTICE',
    id: checkpoint?.id,
    diamond: checkpoint?.diamond,
    viewerCanAccess: checkpoint?.viewerCanAccess,
  };
});

export const listPartAtom = atom((get) => {
  const checkpoint = get(checkPointAtom);
  if (!checkpoint?.checkPointIeltsSpeakingParts) return [];
  return checkpoint.checkPointIeltsSpeakingParts;
});

export const currentPartAtom = atom((get) => {
  const partIndex = get(currentPartIndexAtom);
  const listPart = get(listPartAtom);
  return listPart[partIndex];
});

export const nextPartInfoAtom = atom((get) => {
  const partIndex = get(currentPartIndexAtom);
  const listPart = get(listPartAtom);
  return listPart[partIndex + 1];
});

export const listQuestionInPartAtom = atom((get) => {
  const currentPart = get(currentPartAtom);
  if (!currentPart?.node.ieltsSpeakingPartQuestions) return [];
  return currentPart.node.ieltsSpeakingPartQuestions;
});

export const currentQuestionAtom = atom((get): IeltsSpeakingQuestion | undefined => {
  const currentPart = get(currentPartAtom);
  const currentQuestionIndex = get(currentQuestionIndexAtom);
  if (!currentPart?.node.ieltsSpeakingPartQuestions) return;
  return currentPart?.node.ieltsSpeakingPartQuestions[currentQuestionIndex]
    ?.node as IeltsSpeakingQuestion;
});

export const questionNavigationInfoAtom = atom((get) => {
  const currentQuestionIndex = get(currentQuestionIndexAtom);
  const currentPartIndex = get(currentPartIndexAtom);
  const listPart = get(listPartAtom);
  const listQuestion = get(listQuestionInPartAtom);

  
  if (listPart.length === 0) {
    // list part === 0
    return {
      isLastPart: true,
      isLastQuestion: true,
    };
  }
  const isLastPart = currentPartIndex === listPart.length - 1;
  const isLastQuestion = currentQuestionIndex === (listQuestion?.length || 0) - 1;

  
  return {
    isLastPart,
    isLastQuestion,
  };
});

export const nextQuestionAtom = atom(null, (get, set) => {
  // logic next question

  const { isLastQuestion, isLastPart } = get(questionNavigationInfoAtom);
  if (isLastPart && isLastQuestion) {
    // show modal submit ShowBottomSheetSubmitExamAtom
    set(isShowBottomSheetSubmitTestAtom, true);
    return;
  }
  if (isLastQuestion) {
    // last question => next part => show part info
    set(isShowBottomSheetSubmitTestAtom, true);
    return;
  }
  set(currentQuestionIndexAtom, (prev) => prev + 1);
});

export const speakingSubmitAttemptCallbackAtom = atomWithReset<(() => Promise<void>) | undefined>(
  undefined,
);
